import React from 'react';
import { Col, Form, Row } from 'components';
import { FormModal } from 'components/common';
import { Input } from 'antd';
import { useOnlineShopAddEditModal } from 'feature/supplierTabs/priceList/onlineShop/addEdit/useOnlineShopAddEditModal';
import { webSiteUrlRegex } from 'utils/helpers';
import { ValidationErrors } from 'constants/validations';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';

const { Item } = Form;

export type CountryClientPricingRuleType = {
  countryId: string;
  clientTypePricingRulesId: string;
  clientTypeId: string;
  markup: number;
  minMargin: number;
  maxMargin: number;
};

export interface IEditPricing {
  modalState: boolean;
  onModalStateChange: () => void;
  dataToEdit?: Record<string, any>;
}

export const OnlineShopAddEditModal = React.memo((props: IEditPricing) => {
  const { onModalStateChange, modalState, dataToEdit } = props;
  const { onFinish, contextHolder, form, isLoading, onCancel } = useOnlineShopAddEditModal({
    onModalStateChange,
    modalState,
    dataToEdit,
  });
  return (
    <>
      {contextHolder}
      <FormModal
        form={form}
        title={`${dataToEdit ? 'Update' : 'Add'} Online Shop`}
        okText={dataToEdit ? 'Save' : 'Add'}
        open={modalState}
        width={400}
        isLoading={isLoading}
        onCancel={onCancel}
        onSubmit={onFinish}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Item
              label={'Website Link*'}
              name={'webSiteLink'}
              rules={[
                {
                  required: true,
                  message: ValidationErrors.required('Website Link'),
                },
                { pattern: webSiteUrlRegex, message: 'Please enter a valid website URL.' },
              ]}
            >
              <Input size={'large'} />
            </Item>
          </Col>
          <Col span={24}>
            <Item
              label={'Login'}
              name={'login'}
              dependencies={['password']}
              rules={[
                {
                  validator(_, value) {
                    const password = form.getFieldValue('password');
                    if (password && !value) {
                      return Promise.reject(new Error(ValidationErrors.required('Login')));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input size={'large'} />
            </Item>
          </Col>
          <Col span={24}>
            <Item
              label={'Password'}
              name={'password'}
              dependencies={['login']}
              rules={[
                {
                  validator(_, value) {
                    const login = form.getFieldValue('login');
                    if (login && !value) {
                      return Promise.reject(new Error(ValidationErrors.required('Password')));
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input.Password
                iconRender={(visible) => (visible ? <EyeInvisibleOutlined /> : <EyeOutlined />)}
                size={'large'}
              />
            </Item>
          </Col>
        </Row>
      </FormModal>
    </>
  );
});
